export const makePbUpSecondName = ({ cate_item }) => {
  return `${cate_item['name' + G._en] || cate_item.name || ''}`;
};
